import { getCommercialInboundConfirm, getResearchInboundConfirm, } from "../api/generated/wrappers/inbound";
import { getCommercialPurchaseForInbound, getResearchPurchaseForInbound, } from "../api/generated/wrappers/inbound";
import { getCommercialInboundProducts, getResearchInboundProducts, } from "../api/generated/wrappers/inbound";
import { getCommercialInboundProductAll, getResearchInboundProductAll, } from "../api/generated/wrappers/inbound";
import { createQueryKeys } from "./create-query-keys";
const inboundQueryKeys = createQueryKeys("inbound", {
    confirm: (isCommercial, params) => ({
        queryKey: ["confirm", isCommercial, params],
        queryFn: async () => isCommercial
            ? await getCommercialInboundConfirm(params)
            : await getResearchInboundConfirm(params),
    }),
    productAll: (isCommercial, params) => ({
        queryKey: ["productAll", isCommercial, params],
        queryFn: async () => isCommercial
            ? await getCommercialInboundProductAll(params)
            : await getResearchInboundProductAll(params),
    }),
    products: (isCommercial, inboundId) => ({
        queryKey: ["products", isCommercial, inboundId],
        queryFn: async () => isCommercial
            ? await getCommercialInboundProducts(inboundId)
            : await getResearchInboundProducts(inboundId),
    }),
    purchase: (isCommercial, params) => ({
        queryKey: ["purchase", isCommercial, params],
        queryFn: async () => isCommercial
            ? await getCommercialPurchaseForInbound(params)
            : await getResearchPurchaseForInbound(params),
    }),
});
export default inboundQueryKeys;
